<template>
    <div class="org-select-dialog">
        <v-dialog
            v-model="show"
            :title="title"
            :confirm-loading="confirmLoading"
            class="org-select-dialog-box"
            kind="modal"
            @confirm="onConfirm"
            @show="onShow"
        >
            <slot name="status-tip" />
            <org-select-inner
                :key="selectKey"
                v-bind="$attrs"
                :show="showInner"
                @change="onChange"
            />
            <template slot="confirm-text">
                {{ confirmText }}
            </template>
            <template
                v-if="$slots.footer"
                slot="footer"
            >
                <slot name="footer" />
            </template>
        </v-dialog>
        <span
            class="org-select-trigger"
            @click.stop="triggerClick"
        >
            <slot name="trigger"><a href="javascript:;">选择</a></slot>
        </span>
    </div>
</template>

<script>
import OrgSelectInner from './org-select-inner';
import OrgSelectMixin from './mixins';

export default {
  components: {
    OrgSelectInner,
  },

  mixins: [OrgSelectMixin],

  props: {
    title: {
      type: String,
      default() {
        return this.$t('选择员工');
      },
    },

    custTriggerClick: {
      type: Boolean,
      default: false,
    },

    confirmText: {
      type: String,
      default() {
        return this.$t('确定');
      },
    },

    // 是否每次显示都重新渲染org-select-inner组件
    showUpate: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      show: false,
      selectKey: `org-select_${Date.now()}`,
      confirmLoading: false,
    };
  },

  methods: {
    showDialog() {
      this.show = true;

      if (this.showUpate) {
        this.updateKey();
      }
    },

    hideDialog() {
      this.show = false;
    },

    updateKey() {
      this.selectKey = `org-select_${Date.now()}`;
    },

    triggerClick() {
      if (!this.custTriggerClick) {
        this.showDialog();
      }

      this.$emit('triggerClick', this.showDialog);
    },

    showConfirmLoading() {
      this.confirmLoading = true;
    },

    hideConfirmLoading() {
      this.confirmLoading = false;
    },

    getSelectedArr() {
      return this.selectedArr;
    },
  },
};
</script>
